module.exports = "mutation DeleteCard($id: ID!) {\n  deleteCard(id: $id) {\n    deleted\n  }\n}\n"